import HTTP_METHOD from "enums/HTTP_METHOD";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";
import IndividualItemResponse from "types/IndividualItemResponse";
import UserResponseDto from "types/UserResponseDto";

export default function useSetPassword() {
  const { write, ...rest } = useApiWrite();

  function setPassword(
    password: string,
    token: string,
  ): Promise<IndividualItemResponse<UserResponseDto>> {
    return write<IndividualItemResponse<UserResponseDto>>({
      url: endpoints.putResetPassword(token),
      method: HTTP_METHOD.PUT,
      data: { password },
    }).then(({ data }) => data);
  }

  return { setPassword, ...rest };
}
